<template>
    <nav class="menu">
        <div class="frame">
            <div class="logo"><i class="fab fa-atlassian"></i> United Quartz</div>
            <router-link to="/">
                <div :class="['box', { 'box-select': $route.path === '/' }]">
                    <div class="icon">
                        <i class="fas fa-cube"></i>
                    </div>
                    <div class="text">產品管理</div>
                </div>
            </router-link>
            <router-link to="/activity">
                <div :class="['box', { 'box-select': $route.path === '/activity' }]">
                    <div class="icon">
                        <i class="fas fa-clipboard-list"></i>
                    </div>
                    <div class="text">活動管理</div>
                </div>
            </router-link>
            <router-link to="/slider">
                <div :class="['box', { 'box-select': $route.path === '/slider' }]">
                    <div class="icon">
                        <i class="fas fa-exchange-alt"></i>
                    </div>
                    <div class="text">輪播管理</div>
                </div>
            </router-link>
            <router-link to="/contact">
                <div :class="['box', { 'box-select': $route.path === '/contact' }]">
                    <div class="icon">
                        <i class="fas fa-comment"></i>
                    </div>
                    <div class="text">聯絡管理</div>
                </div>
            </router-link>
        </div>
    </nav>
</template>
<script>
export default {
    data() {
        return {}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.menu {
    background: $color-white;
    width: 300px;
    border-right: 1px $color-border solid;
    overflow: hidden;
    min-height: 100vh;
    .frame {
        a {
            text-decoration: none;
        }
    }
    .logo {
        color: $color-black-2;
        line-height: 60px;
        font-weight: bold;
        font-size: $font-size-5;
        font-family: 'Arial Black', 'Arial';
        padding-left: 40px;
    }
    .box {
        width: 100%;
        display: flex;
        line-height: 50px;
        font-size: $font-size-6;
        color: $color-black-3;
        padding: 0 5px;
        border-left: 5px solid $color-white;
        cursor: pointer;
        .icon {
            width: 40px;
            text-align: center;
        }
        .text {
            font-family: $font-3;
            letter-spacing: 2px;
        }
    }
    .box-select {
        color: $color-blue;
        border-left: 5px solid $color-blue;
        padding-left: 5px;
        background: $color-background;
    }
    .box:hover {
        color: $color-blue;
        border-left: 5px solid $color-blue;
        padding-left: 5px;
        transition: all 1s ease;
        background: $color-background;
    }
}
</style>
